import {
  INameOtpSendAPIPayload,
  INameOtpSendAPIResponse,
  INameOtpVerifyAPIPayload,
  INameOtpVerifyAPIResponse,
  ISaveLeadPayload,
  ISaveLeadResponse,
} from "../types/open-demat-button-types.types";
import { API_PATHS } from "../constants/api-paths";
import { encryptedRequest } from "../core/api.client";

export const bfslSendOtp = async (payload: INameOtpSendAPIPayload) => {
  const response: INameOtpSendAPIResponse = await encryptedRequest({
    method: "POST",
    url: API_PATHS.bfslOtpSend,
    data: payload,
  });

  return response;
};

export const bfslVerifyOtp = async (payload: INameOtpVerifyAPIPayload) => {
  const response: INameOtpVerifyAPIResponse = await encryptedRequest({
    method: "POST",
    url: API_PATHS.bfslOtpVerify,
    data: payload,
  });

  return response;
};

export const bfslSaveLead = async (payload: ISaveLeadPayload) => {
  const response: ISaveLeadResponse = await encryptedRequest({
    method: "POST",
    url: API_PATHS.bfslSaveLead,
    data: payload,
  });

  return response;
};
